<template>
  <nav class="top-0 fixed z-50 w-full flex items-center justify-between px-2 py-3 bg-white shadow">
    <div class="flex items-center justify-between w-full max-w-full mx-auto">

      <!-- 左边 Home -->
      <ul class="flex list-none">
        <li class="flex items-center">
          <router-link
              class="hover:text-blue-500 text-gray-700 px-2 py-2 flex items-center text-lg font-bold"
              to="/"
          >
            <i class="bi bi-house me-1"></i>
            Home
          </router-link>
        </li>
      </ul>

      <!-- 右边菜单，增加间距 -->
      <ul class="flex list-none items-center space-x-4 lg:space-x-6">
        <li class="flex items-center">
          <router-link class="nav-link" to="/singlecellinfo">Single Cell</router-link>
        </li>
        <li class="flex items-center">
          <router-link class="nav-link" to="/tutorial">Contact Us</router-link>
        </li>
        <li class="flex items-center">
          <router-link to="/download">
            <button class="download-btn">
              <i class="fas fa-download"></i> Download
            </button>
          </router-link>
        </li>
      </ul>

      <!-- 手机端汉堡 -->
      <button
          class="lg:hidden ml-2 text-xl p-1 border border-transparent rounded bg-transparent focus:outline-none"
          type="button"
          @click="setNavbarOpen"
      >
        <i class="fas fa-bars"></i>
      </button>

    </div>
  </nav>
</template>

<script>
export default {
  data() {
    return { navbarOpen: false };
  },
  methods: {
    setNavbarOpen() {
      this.navbarOpen = !this.navbarOpen;
    },
  },
};
</script>

<style scoped>
.nav-link {
  font-size: 14px;
  font-weight: 600;
  padding: 4px 8px;
  color: #374151;
  transition: 0.2s;
}
.nav-link:hover {
  color: #409eff;
}
.download-btn {
  background: #409eff;
  color: white;
  padding: 4px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  transition: 0.2s;
}
.download-btn:hover {
  background: #1d78d7;
}
</style>